import {PortChunk} from "../../chunks/types/PortChunk";
import {getPortNameFromPortDeclChunk} from "./getPortNameFromPortDeclChunk";

export function getPortNameFromPortChunk(
  portChunk: PortChunk
): string {
  const {
    captures: {
      2: portDeclChunk
    }
  } = portChunk;
  return getPortNameFromPortDeclChunk(portDeclChunk);
}
